import React from "react";
import PropTypes from "prop-types";
import { VideoPlayer } from "@lululemon/ui-library";

export const VisualStoryGridVideo = ({ video, videoRef }) => {
  const { title, videoUrl, videoPreviewImageUrl, videoCaptionsUrl } =
    video || {};
  const isAdaptive = video?.videoUrl?.includes(".m3u8");

  return (
    <VideoPlayer
      allowAudio
      analyticsTitle={title}
      captionProps={{ src: videoCaptionsUrl }}
      // landscape only
      orientation="landscape"
      landscapeSource={!isAdaptive ? videoUrl : null}
      landscapeAdaptiveSource={isAdaptive ? videoUrl : null}
      landscapePosterImageProps={{
        alt: title,
        lazy: true,
        maxWidth: 1300,
        src: videoPreviewImageUrl
      }}
      refs={{ video: videoRef }}
    />
  );
};

VisualStoryGridVideo.propTypes = {
  video: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    videoUrl: PropTypes.string,
    videoPreviewImageUrl: PropTypes.string,
    videoCaptionsUrl: PropTypes.string
  }).isRequired
};
